import { useAuthContext } from "../contexts/AuthContext";

const usePermission = ({ permission }) => {
    const { userInfo } = useAuthContext();

    if (!userInfo || !userInfo.p) return false;
    else {
        let havePermission = userInfo.p.find(p => p.name === permission);
        if (havePermission) return true;
        else return false;
    }
}

export default usePermission;